import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faEnvelope, 
  faPhone, 
  faMapMarkerAlt
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

const LandingFooter: React.FC = () => {
  // @ts-ignore - react-i18next supports namespace parameter but TypeScript types don't reflect it
  const { t } = useTranslation('footer');
  const { lang } = useParams<{ lang: string }>();
  
  return (
    <footer className="bg-gradient-to-b from-gray-900 to-gray-800 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-8 sm:mb-12">
          {/* Brand Section */}
          <div className="sm:col-span-2 lg:col-span-2">
            <div className="flex items-center mb-4 sm:mb-6">
              <img 
                src="/logo.svg" 
                alt="Winnomi Logo" 
                className="w-16 h-16 sm:w-20 sm:h-20 object-contain"
              />
            </div>
            
            <p 
              className="text-white/70 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base"
              // style={{
              //   orphans: 4,
              //   widows: 4,
              //   textWrap: 'pretty',
              //   // Safari fallback
              //   WebkitHyphens: 'auto',
              //   MozHyphens: 'auto',
              //   hyphens: 'auto',
              //   wordBreak: 'keep-all',
              //   overflowWrap: 'break-word'
              // }}
            >
              {t('description')}
            </p>

            {/* Contact Info */}
            {/* <div className="space-y-3">
              <div className="flex items-center space-x-3 text-white/70">
                <FontAwesomeIcon icon={faEnvelope} className="text-purple-400" />
                <span>info@winnomi.com</span>
              </div>
              <div className="flex items-center space-x-3 text-white/70">
                <FontAwesomeIcon icon={faPhone} className="text-purple-400" />
                <span>+90 532 342 87 393</span>
              </div>
              <div className="flex items-center space-x-3 text-white/70">
                <FontAwesomeIcon icon={faMapMarkerAlt} className="text-purple-400" />
                <span>İstanbul, Türkiye</span>
              </div>
            </div> */}
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-3 sm:mb-4 text-sm sm:text-base">{t('quickLinks')}</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <a 
                  href="#features" 
                  className="text-white/70 md:hover:text-white transition-colors text-sm sm:text-base"
                >
                  {t('features')}
                </a>
              </li>
              <li>
                <a 
                  href="#pricing" 
                  className="text-white/70 md:hover:text-white transition-colors text-sm sm:text-base"
                >
                  {t('pricing')}
                </a>
              </li>
              <li>
                <a 
                  href={`/${lang}/kullanim-kosullari`} 
                  className="text-white/70 md:hover:text-white transition-colors text-sm sm:text-base"
                >
                  {t('termsOfUse')}
                </a>
              </li>
              <li>
                <a 
                  href={`/${lang}/gizlilik-politikasi`} 
                  className="text-white/70 md:hover:text-white transition-colors text-sm sm:text-base"
                >
                  {t('privacyPolicy')}
                </a>
              </li>
              <li>
                <a 
                  href={`/${lang}/kvkk-aydinlatma-metni`} 
                  className="text-white/70 md:hover:text-white transition-colors text-sm sm:text-base"
                >
                  {t('kvkk')}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-3 sm:mb-4 text-sm sm:text-base">{t('contact')}</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li className="text-white/70 text-sm sm:text-base flex items-start sm:items-center">
                <FontAwesomeIcon icon={faEnvelope} className="text-purple-400 mr-2 mt-0.5 sm:mt-0 flex-shrink-0" />
                <a 
                  href="mailto:info@winnomi.com" 
                  className="break-all hover:text-white transition-colors cursor-pointer"
                >
                  info@winnomi.com
                </a>
              </li>
              <li className="text-white/70 text-sm sm:text-base flex items-center">
                <FontAwesomeIcon icon={faPhone} className="text-purple-400 mr-2 flex-shrink-0" />
                <a 
                  href="tel:+905465975643" 
                  className="hover:text-white transition-colors cursor-pointer"
                >
                  +90 546 597 56 43
                </a>
              </li>
              <li className="text-white/70 text-sm sm:text-base flex items-start sm:items-center">
                <FontAwesomeIcon icon={faMapMarkerAlt} className="text-purple-400 mr-2 mt-0.5 sm:mt-0 flex-shrink-0" />
                <span>İstanbul, Türkiye</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="flex flex-col sm:flex-row items-center justify-between pt-6 sm:pt-8 border-t border-white/10">
          <div className="text-white/60 text-xs sm:text-sm mb-4 sm:mb-0 text-center sm:text-left">
            {t('common.allRightsReserved')}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
